/// Preenche as variáveis aqui porque nenhum servidor mexe na resposta rápida depois de inserida.
/// As chaves espelham LeadTemplateVariables no servidor: mudar uma lista exige mudar a outra.

export interface LeadVariableValues {
    name?: string | null;
    phone?: string | null;
    email?: string | null;
    status?: string | null;
    owner?: string | null;
    source?: string | null;
    /// Quem está enviando, ou seja, o usuário logado.
    agent?: string | null;
}

/// Data no mesmo formato que o servidor usa em {{hoje}}.
const today = () => new Date().toLocaleDateString('pt-BR');

export const fillLeadVariables = (text: string, values: LeadVariableValues): string => {
    if (!text) return text;

    const map: Record<string, string> = {
        // Apelido antigo: há conteúdo salvo usando ele desde antes do catálogo.
        nome: values.name ?? '',
        lead_name: values.name ?? '',
        lead_phone: values.phone ?? '',
        lead_email: values.email ?? '',
        lead_status: values.status ?? '',
        lead_owner: values.owner ?? '',
        lead_source: values.source ?? '',
        atendente: values.agent ?? '',
        hoje: today(),
    };

    return Object.entries(map).reduce(
        (current, [key, value]) => current.split(`{{${key}}}`).join(value),
        text
    );
};
